import { ENewbuildingSnippetType } from '../types/offer';

export function isNewbuildingSnippetAvailable(snippetType?: ENewbuildingSnippetType) {
  return snippetType === ENewbuildingSnippetType.Advanced || snippetType === ENewbuildingSnippetType.Maximum;
}
